/* global _satellite */
import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { isInvestor } from '../../../global/authentication/authentication-manager'

const updateArray = (array, entry, add) => {
  const indexOfEntry = array.indexOf(entry)

  if (indexOfEntry > -1) {
    if (!add) {
      array.splice(indexOfEntry, 1)
    }
  } else {
    if (add) {
      array.push(entry)
    }
  }
}

const titleCase = (str) => {
  return (
    (str &&
      str
        .toLowerCase()
        .split(' ')
        .map(function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1)
        })
        .join(' ')) ||
    ''
  )
}

const convertDate = (d) => {
  const date = new Date(d)
  if (d && date instanceof Date && !isNaN(date)) {
    const dateSplit = d.split('-')
    const day = dateSplit[2].split('T')[0]

    return `${dateSplit[1]}/${day}/${dateSplit[0]}`
  }

  return ''
}

const renderInvestorGoalsIcons = (fund) => {
  if (!isInvestor()) {
    const filter =
      fund &&
      fund.filters &&
      fund.filters.find((filter) => filter.filter === 'investorGoal')

    if (filter && filter.filterValue) {
      return (
        <>
          {filter.filterValue.map((filterVal) => {
            return (
              <div
                key={filterVal.code}
                className={
                  'icon-32 ' +
                  'icon-' +
                  lookupIcon(filterVal.code) +
                  '-blue-ltblue'
                }
              />
            )
          })}
        </>
      )
    }
  }

  return null
}

const lookupCategory = (categoryname) => {
  switch (categoryname) {
    case 'Domestic Equity':
      return 'domestic-equity'
    case 'International Equity':
    case 'Global/International Equity':
      return 'international-equity'
    case 'Sector Equity/Specialty':
      return 'sector-equity'
    case 'Asset Allocation/Alternative':
    case 'Asset Allocation':
      return 'asset-allocation'
    case 'Alternative':
      return 'alternative'
    case 'Taxable Fixed Income':
      return 'taxable-fixed-income'
    case 'Tax-Exempt Fixed Income':
      return 'tax-exempt-fixed-income'
    case 'Money Market':
      return 'money-market'
    default:
      return ''
  }
}

const lookupIcon = (code) => {
  switch (code.trim()) {
    case 'IG1':
      return 'plan-retirement'
    case 'IG5':
      return 'grow-assets'
    case 'IG4':
      return 'navigate-rates'
    case 'IG3':
      return 'ease-impact'
    case 'IG2':
      return 'maximize-returns'
    default:
      return ''
  }
}

const filterAnalyticsTag = (pathname) => {
  if (pathname.includes('exchange-traded-funds')) {
    return 'exchange-traded-funds-filter-checkbox'
  } else if (pathname.includes('investor')) {
    return 'investor-mutual-funds-filter-checkbox'
  } else {
    return 'mutual-funds-filter-checkbox'
  }
}

const filterAnalyticsSatellite = (tagString, pathname) => {
  if (pathname.includes('exchange-traded-funds')) {
    _satellite.track('exchangeTradedFundsViewResults', tagString)
  } else if (pathname.includes('investor')) {
    _satellite.track('investorsMutualFundsViewResults', tagString)
  } else {
    _satellite.track('mutualFundsViewResults', tagString)
  }
}

const hasFundDistributionsEstimates = (fund, unit) => !!fund?.[unit]

const formatToFixed = (n, d = 2) =>
  new Number(n).toLocaleString('en-US', {
    useGrouping: false,
    minimumFractionDigits: d,
    maximumFractionDigits: d,
  })

const isPresentFundEstimates = (funds) =>
  funds.some((i) => !isEmpty(i?.estimates))

export {
  updateArray,
  titleCase,
  convertDate,
  renderInvestorGoalsIcons,
  lookupCategory,
  lookupIcon,
  filterAnalyticsTag,
  filterAnalyticsSatellite,
  hasFundDistributionsEstimates,
  formatToFixed,
  isPresentFundEstimates,
}
